export * from './DRCAssessmentDetail';
export * from './AcademicAssessments';
export * from './ApplicantParticulars';
export * from './PublicationAssessments';
export * from './MeritAssessments';
export * from './ScoresOnApplicant';
export * from './DeclarationAssessments';
export * from './PanelInterview';
export * from './AcademicRefereeConfirmation';
